import React, { useState, useEffect, useMemo, useCallback } from 'react'
import Card from 'react-bootstrap/Card';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import Helpers from '../../Components/Helpers/Helpers';
import { toast } from 'react-toastify'
import { FormCustom,  Select } from '../../Components/Form/Form'
import ReactPlaceholder from 'react-placeholder'
import Button from 'react-bootstrap/esm/Button';

const PointPeriod = _ => {
    const [ready, setReady] = useState(false)
    const [isProcessing, setIsProccesing] = useState(false)
    const [periodSelected, setPeriodSelected] = useState('')
    const [rows, setRows] = useState({
        money: [],
        details: []
    })
    const [period, setPeriod] = useState([])

    useEffect(() => {
        Controllers.period.get_period().then(res => {
            setPeriod(res.data)
            setReady(true)
        })
    }, [])

    const handleSubmit = _ => {
        setIsProccesing(true)
        Controllers.report.get_report_commissions_period({
            p_id_period: periodSelected
        }).then(res => {
            setRows(res.data)
        }).catch(req => Helpers.promise.catch({ req, toast }))
        .finally(() => {
            setIsProccesing(false)
        })
    }

    const moneyList = useCallback(() => {
        let m = []
        for (const key in rows.money) {
            m.push(<div className="ui-totals-row" key={key}>
                <span>{key}</span>
                <span>{rows.money[key]}</span>
            </div>)
        }
        return m
    }, [rows])

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        head={[
            [
                { name: 'key_branch_office', text: 'Sucursal', align: 'center', sort: false },
                { name: 'id_customers', text: 'ID', align: 'center', sort: false },
                { name: 'full_name', text: 'Nombres', sort: false },
                { name: 'name_plan', text: 'Rango', sort: false },
                { name: 'subtotal_earnings', text: 'Ganancia', align: 'center', sort: false, render: r => '$ ' + r.subtotal_earnings },
                { name: 'isr', text: 'ISR', align: 'center', sort: false, render: r => '$ ' + r.isr },
                { name: 'total', text: 'Total', align: 'center', sort: false, render: r => '$ ' + r.total },
                { name: 'code_money', text: 'Moneda', align: 'center', sort: false },
            ],
        ]}
        rows={rows.details}
        pageLength={100}
        isProcessing={isProcessing}
        noSort
    />, [rows, isProcessing])

    return <div className="ui-page">
        <div className="ui-page-head">
            <div>
                <h1 className="ui-page-title">Comisiones por Período</h1>
                <p className="ui-page-meta">Filtra por período y revisa el detalle</p>
            </div>
        </div>
        <ReactPlaceholder rows={10} showLoadingAnimation ready={ready}>
            <Card className="ui-list-shell border-0">
                <Card.Header>
                    <span>Filtros y resultados</span>
                </Card.Header>
                <Card.Body>
                    <div className="ui-report-filters">
                    <FormCustom viewSubmit={false}>
                        <Select
                            text="Periódo"
                            classNameParent="col-12 mb-2"
                            options={period.map(p => {
                                return {
                                    label: p.name_period,
                                    value: p.id_period
                                }
                            })}
                            onChange={e => setPeriodSelected(e.value)}
                            append={[
                                <Button variant="primary" onClick={handleSubmit}>
                                    <i className="fa fa-search"></i>
                                </Button>
                            ]}
                        />
                    </FormCustom>
                    </div>
                    <div className="ui-report-result">
                        <p className="ui-form-section-title">Resultados</p>
                        { dtRows }
                    </div>
                </Card.Body>
            </Card>
            {isProcessing ? '' : <div className="ui-totals-panel">
                <p className="ui-form-section-title mb-2">Total de Comisiones</p>
                {moneyList()}
            </div>}
        </ReactPlaceholder>
    </div>
}

export default PointPeriod
